module.exports = new __parcel__URL__("climate_kids.fc05ced5.png").toString();